<ul class="social-media-links">
    <li *ngIf="newsletter" class="social-media-links__newsletter">
        <a [href]="newsletter" target="_blank" rel="noopener noreferrer" aria-label="Newsletter">
            <mg-menu-icon type="mailbox"></mg-menu-icon>
        </a>
    </li>
    <li *ngIf="instagram" class="social-media-links__instagram">
        <a [href]="instagram" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <mg-menu-icon type="instagram"></mg-menu-icon>
        </a>
    </li>
    <li *ngIf="facebook" class="social-media-links__facebook">
        <a [href]="facebook" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <mg-menu-icon type="facebook"></mg-menu-icon>
        </a>
    </li>
    <li *ngIf="linkedin" class="social-media-links__linkedin">
        <a [href]="linkedin" target="_blank" rel="noopener noreferrer" aria-label="Linked In">
            <mg-menu-icon type="linkedin"></mg-menu-icon>
        </a>
    </li>
    <li *ngIf="twitter" class="social-media-links__twitter">
        <a [href]="twitter" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
            <mg-menu-icon type="twitter"></mg-menu-icon>
        </a>
    </li>
</ul>
